module.exports = __webpack_public_path__ + "media/images/1-70e1f8f43f59ad0313e076aa02c87db6.png";